import LoginPortalViaMyServiceTas from "../../Components/MyServiceTas/LoginPortalViaMyServiceTas";

const LoginViaMyServiceTasPage = () => {
    return ( 
        <LoginPortalViaMyServiceTas/>
     );
}
 
export default LoginViaMyServiceTasPage;